import { useParams } from 'react-router-dom';
import { ResultContainer } from "../domain/result";
import { Header } from "../utilities/Header";
import { Footer } from "../utilities/Footer";

const ResultPage: React.FC = (props) => {
	
	const { id } = useParams() as { id: string };
	
	return (
		<>
			<section id="section-main" className="section section-main">
				<div className="container-fluid">
					<Header />
					<ResultContainer id={id} />
				</div>
			</section>
			<Footer />
		</>
	);
};

export { ResultPage };
